module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_nordland_neg.971d5b57.png";